import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card"
import UserManagement from "../Users"
import CalculadorTasas from "../CalculadorTasas"
import SolicitudesPage from "../Solicitudes"
import ReportesPage from "../Reportes"
import CreditosPage from "../Creditos"

export default function Dashboard() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-muted-foreground">Bienvenido al panel de administración de Gamaan.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Solicitudes recientes</CardTitle>
          <CardDescription>Gestiona las solicitudes de crédito recibidas.</CardDescription>
        </CardHeader>
          <SolicitudesPage />
      </Card>

        
      <Card>
        <CardHeader>
          <CardTitle>Créditos recientes</CardTitle>
          <CardDescription>Gestiona los créditos otorgados recientemente.</CardDescription>
        </CardHeader>
          <CreditosPage />
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Gestión de Usuarios</CardTitle>
          <CardDescription>Visualiza y cambia los roles de los usuarios del sistema.</CardDescription>
        </CardHeader>
          <UserManagement />
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Simulador de Crédito</CardTitle>
          <CardDescription>Visualiza y simula diferentes opciones de crédito.</CardDescription>
        </CardHeader>
          <CalculadorTasas />
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Reportes</CardTitle>
          <CardDescription>Visualiza y genera reportes de las solicitudes.</CardDescription>
        </CardHeader>
          <ReportesPage />
      </Card>

      
    </div>
  )
}
